import request from '../../utils/request';
import { Search } from '@/DTOS/TimeKeeperEmployer/Search';

const TimeKeeperEmployerService = {
  search: (search: Search) => {
    return request('/timeKeeperEmployer/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; reference:any; }} */ formData: {
      name: any;
      reference: any;
    }
  ) => {
    return request('/timeKeeperEmployer/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          reference: formData.reference,
        },
      }),
    });
  },
};

export default TimeKeeperEmployerService;
